import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { HireItem } from '../../../../models';
import { HireItemListStoreService } from '../hire-item-list-store.service';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { FileSizePipe } from '../../../pipes/file-size.pipe';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-add-hire-item-attachment',
    templateUrl: './add-hire-item-attachment.component.html',
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, ReactiveFormsModule, NgIf, NgFor, MatIcon, MatFormField, MatLabel, MatInput, MatSelect, MatOption, MatDialogActions, MatButton, MatDialogClose, AsyncPipe, FileSizePipe]
})
export class AddHireItemAttachmentComponent {
  form = new FormGroup({
    files: new FormControl<File[]>(null, Validators.required),
    description: new FormControl<string>(null, Validators.required),
    stage: new FormControl<string>(null, Validators.required)
  });

  uploading$ = this.store.uploading$;

  stages = [
    { value: 'on_hire', label: 'On Hire' },
    { value: 'off_hire', label: 'Off Hire' },
    { value: 'during_hire', label: 'During Hire' },
    { value: 'delivery', label: 'Delivery' },
    { value: 'collection', label: 'Collection' }
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: HireItem,
    private store: HireItemListStoreService,
    private dialogRef: MatDialogRef<AddHireItemAttachmentComponent>
  ) {
    this.setDefaultStage();
  }

  setDefaultStage() {
    if (this.data.off_hire) {
      this.form.get('stage').setValue('off_hire');
      return;
    }
  }

  handleFileInput(eventTarget: EventTarget) {
    const files = (eventTarget as HTMLInputElement).files;
    if (files.length) {
      this.form.patchValue({ files: Array.from(files) });
    } else {
      this.form.patchValue({ files: null });
    }
  }

  uploadAttachment() {
    if (this.form.valid) {
      this.store.addAttachments({
        payload: {
          ...this.form.value,
          hire_item_id: this.data.id,
          uuid: crypto.randomUUID()
        } as any,
        onSuccess: () => this.dialogRef.close()
      });
    }
  }
}
